<!--  -->
<template>
    <div>
        <div class='e-header'>
            <router-link to="/machinemana/0" style="float: left; color: #fff;text-decoration: none;"><i class="el-icon-s-home"></i> 返回</router-link>
            组态编辑
        </div>
        <div class="tool-box">
            <span @click="handleDelete">删除选中</span>
            <span @click="handleCopy">复制</span>
            <span @click="handleClear">清空</span>
            <span @click="handleSave">保存</span>
            <span @click="handlePumbGroup">设置水泵组</span>
        </div>

        <!-- 设置水泵组地址框 -->
        <cmp-pump-dialog :visible="visible" :form="itemData" @handleCloseDialog="handleCloseDialog"></cmp-pump-dialog>
    </div>
</template>

<script>
import bus from "@/utils/bus";
import cmpPumpDialog from './cmpPumpDialog'

export default {
    name:  'eheader',
    props: {
        dragGroup: {
            type: Object,
        },
        currentNode: {
            type: Object,
        }
    },
    data() {
        return {
            pumb_group: null,
            visible: false,
            itemData: {},
        };
    },

    components: { cmpPumpDialog },

    computed: {},
    mounted() {
        this.handleKeyEvent();
    },

    methods: {
        // 新建场景
        handleAddScene() {

        },
        handleSave() {
            try {
                this.currentNode.selectize(false).resize("stop")
            } catch (error) {
                
            }
            bus.$emit('save')
        },
        handleDelete() {
            try {
                this.currentNode.selectize(false).resize("stop")
                this.currentNode.remove()
                this.$emit('deleteNode', true)
            } catch (error) {
                this.$emit('deleteNode', false)
            }

        },
        handleClear() {
            this.dragGroup.clear()
        },
        // 设置水泵组
        handlePumbGroup() {
            let members = SVG.select('.pumb_group').members
            console.log(members);
            if(members.length === 1) {
                this.pumb_group = members[0]
                let dataset = this.pumb_group.node.dataset
                this.itemData = { dataset }
            }else{
                this.pumb_group = this.dragGroup.group().attr('class', 'pumb_group');
                this.itemData = {}
            }
            this.visible = true;
        },
        handleCloseDialog(data) {
            this.visible = false;
            if(data.flag){
                this.pumb_group.attr('data-params', JSON.stringify(data.data))
            }
        },
        handleKeyEvent() {
            let that = this
            document.onkeydown = function(e) {
                console.log(e.which);
                if (e.shiftKey) {   //  组合键
                    switch (e.which) {
                        // 放大 +-
                        case 187:
                        case 61:
                            
                            break
                        // 缩小 ctrl+-
                        case 189:
                        case 173:
                            
                            break
                        default:
                            break
                    }
                }else {
                    switch (e.which) {
                        case 46:    //  delete键
                            that.handleDelete()
                            break
                        case 40:    //  ↓
                        // 记录当前节点X，Y值
                            move(0,1)
                            break
                        case 38:    //  ↑
                            move(0,-1)
                            break
                        case 37:    //  ←
                            move(-1, 0)
                            break
                        case 39:    //  →
                            move(1, 0)
                            break
                        default:
                            break
                    }
                }
                function move(x, y) {
                    let X = that.currentNode.x(),
                        Y = that.currentNode.y();
                    that.currentNode.move(X + x, Y + y)
                }
            }

            document.onkeyup = function (e) {
                if (e.which === 17) {   // 松开按键
                    
                    return false
                }
            }
        },
        handleCopy() {
            bus.$emit('copy')
        },
    }
}

</script>
<style lang='less' scoped>
.e-header{
    height: 46px;
    line-height: 46px;
    background-color: #266cba;
    overflow: hidden;
    color: #fff;
    padding: 0 20px;
    text-align: center;
}
.tool-box{
    padding: 4px 0;
    background-color: #fff;
    font-size: 0;
    span{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        display: inline-block;
        padding: 0 10px;
        cursor: pointer;
    }
}
</style>